mutation changePlan($input: ChangePlanInput!) {
  order: changePlan(input: $input) {
    OrderId
    Currency
    GrossTotal
  }
}
